import React from "react";
import templateStyle from "../../templateEditor.module.css";

interface DocumentViewerProps {
  blob: Blob;
}

const DocumentViewer: React.FC<DocumentViewerProps> = ({ blob }) => {
  const pdfUrl = URL.createObjectURL(blob);

  return (
    <div className={templateStyle.pdfViewer}>
      <iframe
        src={pdfUrl}
        title="PDF Viewer"
        style={{ width: "100%", height: "100%", border: "none" }}
      />
    </div>
  );
};

export default DocumentViewer;
